export default __webpack_public_path__ + "adobe-animate.5cfbdb31.png";